export default __webpack_public_path__ + "static/N0145-450726ec2241ec8cd5d9daa25b607261.png";